import React, { useEffect } from "react";
import AdvSeparator from "../../Common/AdvSeparator";
import { formatWords } from "../../../utils/stringUtils";
import { getEmployeeId } from "../../../utils/getEmployeeId";

//
import { useSelector, useDispatch } from "react-redux";
import StatusTags from "../../Tags/StatusTags";
import { getValueByKey } from "../../../utils/dataMappings";
import Button from "../../Buttons/Button";
import DropdownMenu from "../../Buttons/DropdownMenu";

//
import {
  getEmployeesStart,
  getEmployeeByUiidStart,
  setEmployeeProfileUiid,
} from "../../../redux/slices/employee/employeeSlice";
import Avatar from "../../Common/Avatar";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import NewTable from "../../Table/NewTable";
import { mapTableRows } from "../../../utils";
import { usePagination, useAdvPagination } from "../../../hooks";
import Tag from "../../Tags/Tag";
import NewTableAdv from "../../Table/NewTableAdv";
import TableAdv from "../../Table/TableAdv/TableAdv";

const EmployeeHeader = ({ full = false }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const {
    employeeProfileUiid,
    currentEmployee: { employeeDetails, loadedTabs },
    loading,
    error,
    employees,
    totalCount,
  } = useSelector((state) => state.employee);

  ////

  const { page, limit, setPage, handleLimitChange } = useAdvPagination(5);

  // const { page, limit, setPage, handleLimitChange } = usePagination(
  //   6,
  //   (newPage, newLimit) => {
  //     dispatch(getEmployeesStart({ page: newPage, limit: newLimit }));
  //   },
  // );
  ////

  //Get other employees list
  const empTableData = employees?.data || []; // Add null check with default empty array

  const empColumns = [
    {
      key: "",
      label: "Name",
      render: (row) => (
        <div className="w-full flex items-center gap-2">
          <Avatar
            alt={row.firstName}
            size="sm"
            outline
            src={row.profilePhotoUrl}
          />
          <div className="flex-1 line-clamp-1">
            {[row.firstName, row.middleName, row.lastName]
              .filter(Boolean)
              .join(" ")}
          </div>
        </div>
      ),
      width: "min-w-[300px] max-w-[400px]",
      columnMenu: false,
    },
    {
      key: "code",
      label: "Code",
      render: (row) => (
        <div className="flex items-center gap-1">
          <Link
            to={{
              pathname: location.pathname,
              search: searchParams.toString(),
            }}
            onClick={() => {
              dispatch(setEmployeeProfileUiid(row.uiid));
            }}
          >
            <span className="text-linkblue text-nowrap">
              {getEmployeeId(row.uiid, row.employmentType)}
            </span>
          </Link>
        </div>
      ),
      width: "min-w-[100px]",
      columnMenu: false,
    },

    {
      key: "email",
      label: "Email ID",
      render: (row) => (
        <div className="flex items-center gap-1">
          <span className="text-linkblue">{row.email.primary}</span>
        </div>
      ),
      columnMenu: false,
    },
  ];

  const mappedEmpRows = mapTableRows(empTableData, empColumns);

  useEffect(() => {
    dispatch(
      getEmployeesStart({
        limit,
        page,
        filters: {
          //employmentType: { type: "NONE", value: 3 },
          //"isExit.status": { type: "NONE", value: false },
          // onBench: { type: "NONE", value: false },
          uiid: { type: "NONE", value: { $ne: employeeProfileUiid } },
        },
        ret: "profilePhotoUrl firstName middleName lastName uiid employmentType email",
        sort: {
          uiid: 1,
        },
      }),
    );
  }, [dispatch, page, limit, employeeProfileUiid]); // Empty array will cause it to run once when the component mounts

  ////Get other employees list end

  useEffect(() => {
    if (employeeProfileUiid && !loadedTabs.includes("overview")) {
      dispatch(
        getEmployeeByUiidStart({
          uiid: employeeProfileUiid,
          tab: "overview",
          ret: "uiid profilePhotoUrl firstName middleName lastName jobTitle status employmentType email mobile ssn dob bloodType",
        }),
      );
    }
  }, [employeeProfileUiid, loadedTabs, dispatch]);

  const {
    uiid,
    profilePhotoUrl,
    firstName,
    middleName,
    lastName,
    jobTitle,
    status,
    email,
    mobile,
    employmentType,
  } = employeeDetails || {};

  return (
    <div className="flex gap-3 items-center ">
      {full ? (
        <div className="flex justify-between gap-3 items-center ">
          <div className="flex items-center gap-2  flex-1">
            <div>
              <Avatar size="xxl" src={profilePhotoUrl} alt={firstName} />
            </div>
            <div className="flex justify-start items-center gap-4 flex-1">
              <div className="flex flex-col  justify-between gap-1">
                <div className="flex gap-x-2 gap-y-1 items-center flex-wrap">
                  <h4 className="subtitle-reg line-clamp-1">
                    {[firstName, middleName, lastName]
                      .filter(Boolean)
                      .join(" ")}
                  </h4>
                  <span className="body-two text-neutrals text-nowrap">
                    ({jobTitle})
                  </span>
                  <StatusTags
                    tag={formatWords(
                      "",
                      getValueByKey(status, "EmployeeStatus"),
                    )}
                  />
                </div>
                <div className="flex gap-2 items-center">
                  <Tag
                    title={getEmployeeId(employeeProfileUiid, employmentType)}
                    variant="outlined"
                    color="warning"
                    className=" !text-neutrals !py-1"
                  />
                  <Tag
                    title="Tektree"
                    variant="outlined"
                    color="warning"
                    className=" !text-neutrals !py-1"
                  />
                  <div>
                    <AdvSeparator minItemsPerRow={2}>
                      <span className="body-two text-neutrals leading-none">
                        {email?.primary && email?.primary}
                      </span>

                      <span className="body-two text-neutrals  leading-none">
                        {mobile?.primary && mobile?.primary.code} {` `}
                        {mobile?.primary && mobile?.primary.number}
                      </span>
                    </AdvSeparator>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="body-two flex items-center flex-wrap gap-x-2 gap-y-1 py-1.5 ">
          <div className="text-primary text-nowrap">
            {[firstName, middleName, lastName].filter(Boolean).join(" ")}
          </div>
          <div className="text-primary text-nowrap">
            {getEmployeeId(employeeProfileUiid, employmentType)}
          </div>
          <div className="text-neutrals text-nowrap">
            {email?.primary && email?.primary}
          </div>
          <div className="text-neutrals text-nowrap">
            {mobile?.primary && mobile?.primary.code} {` `}
            {mobile?.primary && mobile?.primary.number}
          </div>
          <StatusTags
            tag={formatWords("", getValueByKey(status, "EmployeeStatus"))}
            icon
            variant="text"
            className="!leading-none !p-0 "
          />
        </div>
      )}
      <div className={`flex-1 flex items-center`}>
        <DropdownMenu
          menuAlign="right" // Align menu to the right
          responsiveWidth={true}
          menuWidth="750px"
          minWidth="200px" // Minimum width
          maxWidth="750px" // Maximum width
          MenuSection={
            <div className="p-1 flex flex-col justify-between h-full max-h-[60vh]">
              {/* <TableAdv
              rows={mappedEmpRows}
              columns={empColumns}
              serverPagination={true}
              tdClassName="!py-1"
              totalCount={totalCount?.data}
              page={page}
              limit={limit}
              onPageChange={setPage}
              onLimitChange={handleLimitChange}
              toolbarRight={[]}
              tableId={"EmployeeDropDownMenuTable"}
              //hideToolBar
            /> */}
              {/* {employeeProfileUiid} */}
              <TableAdv
                rows={mappedEmpRows}
                columns={empColumns}
                serverFiltering={true}
                //onFilterChange={handleFilterChange}
                // need to add table id for every TableAdv for working filter and other features
                tableId={"EmployeeDropDownMenuTable"}
                page={page}
                limit={limit}
                selectList={[5, 10]}
                serverPagination={true}
                totalCount={totalCount?.data}
                onPaginationChange={setPage}
                onLimitChange={handleLimitChange}
                // showCheckbox
                //serverSearchValue={searchValue}
                //serverOnSearch={handleSearch}
                toolbarRight={{
                  search: false,
                  filter: false,
                }}
              />
            </div>
          }
        >
          <Button
            type="icon"
            color="black"
            size="xs-sm"
            icon="keyboard_arrow_down"
            className="rounded-md"
          />
        </DropdownMenu>
      </div>
    </div>
  );
};

export default EmployeeHeader;
